import { useTheme, alpha } from '@mui/material/styles';
import { useMemo } from 'react';

/* eslint-disable @typescript-eslint/ban-ts-comment */
const getOptionStyles = ({ theme, size }) => ({
    option: (provided, state) => {
        const onClick = 'onClick' in state.data ? state.data.onClick : undefined;
        const isNone = 'isNone' in state.data ? state.data.isNone : false;
        const styles = Object.assign(Object.assign({}, provided), { display: 'flex', flexDirection: 'row', alignItems: 'center', color: alpha(theme.palette.N20.main, state.isDisabled ? 0.4 : 1), cursor: state.isDisabled ? 'not-allowed' : 'pointer', backgroundColor: 'transparent', padding: theme.spacing(0.5, 3, 0.5, onClick ? 3 : 2), '#actions': {
                opacity: 0,
            } });
        if (!state.isDisabled) {
            styles[':hover'] = {
                color: theme.palette.N05.main,
                backgroundColor: theme.palette.N30.main,
                '#actions': {
                    opacity: 1,
                },
            };
        }
        if (isNone) {
            styles.fontStyle = 'italic';
            styles.paddingLeft = theme.spacing(size === 'large' ? 11 : 6.5);
        }
        if (size === 'large') {
            styles.fontStyle = 'normal';
            styles.height = '36px !important';
            styles.padding = theme.spacing(2.5, 3);
        }
        return styles;
    },
    input: provided => {
        let styles = Object.assign(Object.assign({}, provided), { margin: 0, padding: 0, color: theme.palette.N05.main });
        if (size === 'large') {
            // @ts-ignore
            styles = Object.assign(Object.assign(Object.assign({}, styles), theme.typography.subtitle1), { input: { textTransform: 'uppercase' } });
        }
        return styles;
    },
    groupHeading: provided => (Object.assign(Object.assign({}, provided), { color: theme.palette.N30.main, fontSize: '11px' })),
    group: provided => (Object.assign(Object.assign({}, provided), { paddingBottom: '0px' })),
});
const useOptionsStyles = ({ size }, stylesConfig) => {
    const theme = useTheme();
    return useMemo(() => (Object.assign(Object.assign({}, stylesConfig), getOptionStyles({ theme, size }))), [theme, stylesConfig, size]);
};

export { useOptionsStyles as default };
//# sourceMappingURL=useOptionStyles.js.map
